var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('h4',{staticClass:"mb-3"},[_vm._v(_vm._s(_vm.$t("pages.home.hi", { name: _vm.userName }))+" 👋")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.$t("pages.home.welcomeText"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }